var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container", staticStyle: { "margin-top": "20px" } },
    [
      _vm.error.statusCode === 404
        ? _c("h1", [_vm._v("Page not found")])
        : _vm.error.statusCode === 401
          ? _c("h1", { staticClass: "title is-2" }, [
              _vm._v("Permission is denied")
            ])
          : _vm.error.statusCode === 501
            ? _c("h1", [_vm._v("Not Implemend Error")])
            : _c("h1", [_vm._v("An error occurred")]),
      _c("p", { staticClass: "subtitle" }, [_vm._v(_vm._s(_vm.error.message))]),
      this.$store.state.authUser != null &&
      this.$store.state.authUser.roleID === "Customer"
        ? _c("a", { attrs: { href: "/customer/dashboard/" } }, [
            _vm._v("\n      Back to home page\n    ")
          ])
        : _vm._e(),
      this.$store.state.authUser != null &&
      (this.$store.state.authUser.roleID === "Admin" ||
        this.$store.state.authUser.roleID === "SuperAdmin")
        ? _c("a", { attrs: { href: "/admin/dashboard/" } }, [
            _vm._v("\n      Back to home page\n    ")
          ])
        : _vm._e(),
      this.$store.state.authUser != null &&
      this.$store.state.authUser.roleID === "Partner"
        ? _c("a", { attrs: { href: "/partner/dashboard/" } }, [
            _vm._v("\n      Back to home page\n    ")
          ])
        : _vm._e(),
      this.$store.state.authUser != null &&
      this.$store.state.authUser.roleID === "Engineer"
        ? _c("a", { attrs: { href: "/engineer/dashboard/" } }, [
            _vm._v("\n      Back to home page\n    ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5ea9138", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5ea9138","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/error.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d5ea9138","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/error.vue
// module chunks = 82